// extracted by mini-css-extract-plugin
module.exports = {"MainLayout":"MainLayout_MainLayout__1qdG-","LayoutSpin":"MainLayout_LayoutSpin__2BN2D","Body":"MainLayout_Body__jXj2S"};